import { render, staticRenderFns } from "./StampsModal.vue?vue&type=template&id=5e386f3f&scoped=true"
import script from "./StampsModal.vue?vue&type=script&lang=js"
export * from "./StampsModal.vue?vue&type=script&lang=js"
import style0 from "./StampsModal.vue?vue&type=style&index=0&id=5e386f3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e386f3f",
  null
  
)

export default component.exports